import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const CloseOutlineIcon = createIcon({
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M4.75 12C4.75 7.99594 7.99594 4.75 12 4.75V4.75C16.0041 4.75 19.25 7.99594 19.25 12V12C19.25 16.0041 16.0041 19.25 12 19.25V19.25C7.99594 19.25 4.75 16.0041 4.75 12V12Z'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M9.75 9.75L14.25 14.25'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M14.25 9.75L9.75 14.25'
    />
  ],
  displayName: 'CloseOutlineIcon',
  defaultProps: defaultProps
})
